import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'

// Initialize Sentry
initSentry()

// Global error handler to filter out third-party script errors
window.addEventListener('error', (event) => {
  const errorMessage = event.message || ''
  const errorSource = event.filename || ''
  
  // Filter out errors from third-party scripts and browser extensions
  if (
    errorMessage.includes('shadowRoot') ||
    errorMessage.includes('Cannot read properties of null') ||
    errorSource.includes('extension://') ||
    errorSource.includes('chrome-extension://') ||
    errorSource.includes('moz-extension://') ||
    errorSource.includes('safari-extension://') ||
    errorSource.includes('googletagmanager.com') ||
    errorSource.includes('google-analytics.com') ||
    errorSource.includes('doubleclick.net') ||
    errorSource.includes('googleadservices.com')
  ) {
    console.log('Filtered out third-party error:', errorMessage, 'from:', errorSource)
    event.preventDefault()
    return false
  }
})

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || event.reason || ''
  
  // Filter out common third-party promise rejections
  if (
    typeof errorMessage === 'string' && (
      errorMessage.includes('shadowRoot') ||
      errorMessage.includes('Script error') ||
      errorMessage.includes('Network request failed') ||
      errorMessage.includes('Failed to fetch')
    )
  ) {
    console.log('Filtered out third-party promise rejection:', errorMessage)
    event.preventDefault()
    return false
  }
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'hsl(var(--background))',
            color: 'hsl(var(--foreground))',
            border: '1px solid hsl(var(--border))',
          },
        }}
      />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
) // Force deployment Wed Sep  3 10:10:50 CEST 2025
